<template>
  <div class="section-container">

    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-graduation-cap mr-2" style="font-size: 20px !important;"></i> Qualification Details
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="qualifications && qualifications.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Degree</th>
              <th>Discipline</th>
              <th>University</th>
              <th>Percentage /CGPA</th>
              <th>Year of Passing</th>
              <th>Special Remarks</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="qualification in sortedQualifications" :key="qualification.id">
              <td>{{ qualification.si_no }}</td>
              <td>{{ qualification.degree }}</td>
              <td>{{ qualification.discipline }}</td>
              <td>{{ qualification.university }}</td>
              <td>{{ qualification.percentage }}</td>
              <td>{{ qualification.year_of_passing }}</td>
              <td>{{ qualification.special_remarks }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editQualification(qualification)"></i>
                <i class="fas fa-trash fa-sm" style="cursor: pointer; color: #dc3545;"
                  @click="deleteQualification(qualification)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Qualification" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateQualification">
        <b-form-group label="SI No">
          <b-form-input v-model="qualification.si_no" type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Degree">
          <b-form-input v-model="qualification.degree"></b-form-input>
        </b-form-group>
        <b-form-group label="Discipline">
          <b-form-input v-model="qualification.discipline"></b-form-input>
        </b-form-group>
        <b-form-group label="University">
          <b-form-input v-model="qualification.university"></b-form-input>
        </b-form-group>
        <b-form-group label="Percentage">
          <b-form-input v-model="qualification.percentage"></b-form-input>
        </b-form-group>
        <b-form-group label="Year of Passing">
          <b-form-input v-model="qualification.year_of_passing"></b-form-input>
        </b-form-group>
        <b-form-group label="Special Remarks">
          <b-form-input v-model="qualification.special_remarks"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      qualification: {
        si_no: "",
        degree: "",
        discipline: "",
        university: "",
        percentage: "",
        year_of_passing: "",
        special_remarks: ""
      },
      qualifications: this.profile.qualifications || [],
    };
  },
  computed: {
    sortedQualifications() {
      return [...this.qualifications].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async createOrUpdateQualification() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/qualifications`;
        let response;

        if (this.editIndex === null) {
          // Create new
          response = await this.$axios.post(url, {
            si_no: Number(this.qualification.si_no),
            degree: this.qualification.degree,
            discipline: this.qualification.discipline,
            university: this.qualification.university,
            percentage: this.qualification.percentage,
            year_of_passing: this.qualification.year_of_passing,
            special_remarks: this.qualification.special_remarks,
            user_profile_id: this.profile.id,
          });
          this.qualifications.unshift(response.data);
        } else {
          // Update existing
          const updateUrl = `${url}/${this.qualification.id}`;
          response = await this.$axios.put(updateUrl, {
            si_no: Number(this.qualification.si_no),
            degree: this.qualification.degree,
            discipline: this.qualification.discipline,
            university: this.qualification.university,
            percentage: this.qualification.percentage,
            year_of_passing: this.qualification.year_of_passing,
            special_remarks: this.qualification.special_remarks,
          });
          this.qualifications.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating qualification:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.qualifications = response.data.qualifications;

      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },

    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },

    editQualification(qualification) {
      this.qualification = { ...qualification };
      this.editIndex = this.qualifications.findIndex(q => q.id === qualification.id);
      this.showModal = true;
    },

    async deleteQualification(qualification) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/qualifications/${qualification.id}`;
        await this.$axios.delete(deleteUrl);
        const index = this.qualifications.findIndex(q => q.id === qualification.id);
        if (index !== -1) {
          this.qualifications.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Qualification deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting qualification:", error);
        this.$toast.error("Failed to delete qualification", { position: "top", duration: 3000 });
      }
    },

    resetForm() {
      this.qualification = {
        si_no: "",
        degree: "",
        discipline: "",
        university: "",
        percentage: "",
        year_of_passing: "",
        special_remarks: ""
      };
      this.editIndex = null;
    }
  }
};
</script>
<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
